import { Theme } from "common";

export const conductOutreachPageContentStyles = {
  root: {
    flexGrow: 1,
  },
  gridContainer: {
    marginBottom: "15px",
    justifyContent: "space-between",
  },
  gridSection: {
    border: `1px solid ${Theme.palette.grey[300]}`,
    padding: "0px 12px",
  },
  outreachTable: {
    border: `1px solid ${Theme.palette.grey[300]}`,
    marginTop: "15px",

    "& tbody>tr:nth-of-type(odd)": {
      backgroundColor: Theme.palette.grey[300],
    },
  },
  bestHeaderCell: {
    color: Theme.palette.success.main,
    "& svg": {
      verticalAlign: "sub",
    },
  },
  worstHeaderCell: {
    color: Theme.palette.warning.main,
    "& svg": {
      verticalAlign: "sub",
    },
  },
  formTextField: {
    width: "100%",
    marginBottom: "15px",
  },
  formButton: {
    marginBottom: "15px",
  },
  disablediconstate: {
    color: Theme.palette.grey[300],
  },
  tableHead: {
    backgroundColor: Theme.palette.primary.light,
    "& .MuiTableSortLabel-icon": {
      alignSelf: "center",
    },
  },
  tableContainerRoot: {
    marginBottom: "20px",
    "& .MuiTableCell-root": {
      border: `1px solid ${Theme.palette.grey[300]}`,
    },
  },
  overflowTableContainer: {
    overflowX: "auto",
  },
  interestedTableCell: {
    backgroundColor: Theme.palette.success.main,
  },
  unsubscribedTableCell: {
    backgroundColor: Theme.palette.warning.main,
  },
  cellWithInfoContainer: {
    display: "inline-flex",
    alignItems: "center",
    "& svg": {
      paddingLeft: "5px",
    },
  },
  cohortSourceTableCell: {
    overflowWrap: "anywhere",
    minWidth: "20ch",
  },
  timePicker: {
    marginTop: "0px",
  },
  performingCohortTableCell: {
    overflowWrap: "anywhere",
  },
  styledTableRow: {
    "& tr:nth-of-type(odd)": {
      backgroundColor: Theme.palette.grey[300],
    },
  },

  selectMarginDense: { margin: 0 },
  disabledIconState: {
    color: Theme.palette.grey[400],
  },
  tableHeadColor: {
    backgroundColor: Theme.palette.primary.light,
  },
  textFieldWidth: { width: "30%" },
  successColor: { color: Theme.palette.success.main },
  customMarginBottom: {
    marginBottom: "20px",
    justifyContent: "space-between",
  },
  noteTableCell: {
    minWidth: "400px",
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "20%",
    left: "45%",
  },
  orange: {
    color: Theme.palette.common.white,
    backgroundColor: Theme.palette.warning.dark,
    width: "15px",
    height: "15px",
  },
  blue: {
    color: Theme.palette.common.white,
    backgroundColor: Theme.palette.info.main,
    width: "15px",
    height: "15px",
  },
  warning: {
    color: Theme.palette.warning.main,
  },
  recurringIcon: {
    width: "15px",
    height: "15px",
  },
};
